<template>
  <div class="workout-picker" @keydown="onKeyDown">
    <!-- custom-select gives it the same down arrow as the other dropdowns -->
    <input
        ref="input"
        v-model="query"
        class="custom-select custom-select-sm"
        autocomplete="off"
        :placeholder="placeholder"
        @focus="open = true"
        @input="open = true; activeIndex = -1"
        @blur="open = false; activeIndex = -1"
    />
    <!-- A Bootstrap dropdown menu, rather than the browser's datalist UI which looks different in every browser -->
    <div v-if="open" class="dropdown-menu show w-100 workout-picker-menu">
      <button
          v-for="(option, i) in matches"
          :key="option.value"
          type="button"
          class="dropdown-item text-truncate"
          :class="{highlighted: i === activeIndex}"
          :title="option.text"
          @mousedown.prevent="select(option)"
          @mouseenter="activeIndex = i"
      >
        {{ option.text }}
      </button>
      <span v-if="matches.length === 0" class="dropdown-item-text text-secondary small">No matching workouts</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WorkoutPicker',
  props: {
    // [{value: workout uuid, text: workout name}]
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: String,
  },
  data() {
    return {
      query: '',
      open: false,
      // The keyboard/mouse highlighted option, -1 for none
      activeIndex: -1,
    }
  },
  computed: {
    matches() {
      const words = this.query.toLowerCase().split(/\s+/).filter(word => word);
      return this.options.filter(option => words.every(word => option.text.toLowerCase().includes(word)));
    },
  },
  methods: {
    select(option) {
      this.$emit('select', option.value);
      this.query = '';
      this.activeIndex = -1;
      this.open = false;
      this.$refs.input.blur();
    },
    onKeyDown(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.open = true;
        const step = event.key === 'ArrowDown' ? 1 : -1;
        this.activeIndex = Math.min(Math.max(this.activeIndex + step, 0), Math.max(this.matches.length - 1, 0));
        this.$nextTick(() => {
          const active = this.$el.querySelector('.dropdown-item.highlighted');
          if (active) {
            active.scrollIntoView({block: 'nearest'});
          }
        });
      } else if (event.key === 'Enter' && this.open && this.matches.length > 0) {
        // Enter picks the highlighted option, or the first match
        event.preventDefault();
        this.select(this.matches[Math.max(this.activeIndex, 0)]);
      } else if (event.key === 'Escape') {
        this.open = false;
      }
    },
  },
}
</script>

<style scoped>
.workout-picker {
  position: relative;
}

.workout-picker .custom-select {
  cursor: text;
}

/* Stand out from the page: a gap below the input, a stronger border and a shadow */
.workout-picker-menu {
  max-height: 16rem;
  overflow-y: auto;
  margin-top: 0.25rem;
  border-color: rgba(0, 0, 0, 0.25);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
}

.workout-picker-menu .dropdown-item.highlighted {
  background-color: #e9ecef;
}
</style>
